import { JSX } from 'react'




export default function (): JSX.Element
{
	return (
		<></>

	)

}
